import React, { useState } from 'react';
import type { DashboardProject } from '../../project/types/project';
import { ProjectFilters } from '../components/ProjectFilters/ProjectFilters';
import { ProjectGrid } from '../components/ProjectGrid/ProjectGrid';
import { useHomePageState } from '../hooks/useHomePageState';
import ProjectCreationForm from '../components/ProjectCreationForm';
import type { HomePageProps } from '../types/home';
import DashedBoard from '../../project/components/dashboard/Index';

export const HomePage: React.FC<HomePageProps> = ({
  showCreateForm,
  onCreateFormClose,
  setSubtitle,
  setShowBackNavigation,
  showBackNavigation
}) => {
  const [selectedProject, setSelectedProject] = useState<DashboardProject | null>(null);

  const {
    searchQuery,
    filters,
    filteredProjects, 
    hasActiveFilters,
    setSearchQuery,
    setFilters,
    resetFilters,
    uniqueCustomers,
    handleProjectClick,
  } = useHomePageState({
    onProjectSelect: setSelectedProject
  });


  return (
    <div className="w-full max-w-[2000px] mx-auto px-4">
      { !showCreateForm && 
      <>

      {selectedProject  && showBackNavigation ?  (
        <>
          {(() => {
            setSubtitle(selectedProject.projectName);
            setShowBackNavigation(true);
            return null;
          })()}
          <DashedBoard
            project={selectedProject}
            onBack={() => setSelectedProject(null)}
          />
        </>
      ) : (
        <>
          <ProjectFilters
            searchQuery={searchQuery}
            onSearchChange={setSearchQuery}
        filters={{
          status: filters.status || 'all',
          type: filters.type || 'all',
          customer: filters.customer || 'all'
        }}
        onFilterChange={(key) => (value) => setFilters(prev => ({ ...prev, [key]: value === 'all' ? undefined : value }))}
        uniqueCustomers={uniqueCustomers}
        hasActiveFilters={hasActiveFilters}
        filteredCount={filteredProjects.length}
        onResetFilters={resetFilters}
      />

      <ProjectGrid
        projects={filteredProjects}
        onProjectClick={handleProjectClick} 
        setShowBackNavigation={setShowBackNavigation}
      />
        </>
      )}
      </>}
      
      {showCreateForm && <ProjectCreationForm onBack={onCreateFormClose} />}
    </div>
  );
}; 